import { Drawer, Table, Button } from "antd";
import Close from "../../assets/images/close-x.svg";
import { getOtherChargesColumns } from "./columnDefinitions";

const OtherChargesDrawer = ({
  otherCharges,
  setOtherCharges,
  tempOtherChargesData,
  setTempOtherChargesData,
  otherChargesData,
  setOtherChargesData,
  savingOtherChargesDataFn,
  firstInputRef,
}) => {
  const columns = getOtherChargesColumns({
    tempOtherChargesData,
    setTempOtherChargesData,
    savingOtherChargesDataFn,
    setOtherChargesData,
    setOtherCharges,
    firstInputRef,
  });

  return (
    <Drawer
      closable={true}
      maskClosable={false}
      placement="bottom"
      title={
        <div style={{ display: "flex", alignItems: "center", height: "2vh", fontSize: "1vw" }}>
          <p style={{ fontSize: "1.5em", marginTop: "3vh", fontWeight: "500", color: "#0F0718", flex: 1, textAlign: "center" }}>Additional Charges</p>
          <img
            src={Close}
            onClick={() => {
              setOtherCharges(false);
              setTempOtherChargesData([...otherChargesData]);
            }}
            style={{ float: "right", cursor: "pointer", marginTop: "-3vh", marginRight: "-0.5vw", width: "1.5vw" }}
          />
        </div>
      }
      closeIcon={null}
      open={otherCharges}
      className="filter"
      styles={{ body: { padding: "0 4vw" } }}
      onClose={() => {
        setOtherCharges(false);
        setTempOtherChargesData([...otherChargesData]);
      }}
      height="90vh"
    >
      <Table
        className="sm-cart-table-pos"
        tableLayout="fixed"
        style={{
          width: "100%",
          overflowY: "auto",
          border: "none",
          borderRadius: "7px",
          padding: "0px 7px",
          height: "67vh",
          background: "#fff",
          marginTop: "2vh",
        }}
        pagination={false}
        sticky
        dataSource={tempOtherChargesData}
        columns={columns}
      />
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <Button
          style={{
            backgroundColor: "#fff",
            color: "#2F3856",
            height: "7vh",
            width: "15vw",
            borderRadius: "7px",
            marginTop: "1rem",
          }}
          onClick={() => {
            setOtherCharges(false);
            setTempOtherChargesData([...otherChargesData]);
          }}
        >
          Cancel
        </Button>
        <Button
          style={{
            backgroundColor: "#2F3856",
            color: "#fff",
            height: "7vh",
            width: "15vw",
            borderRadius: "7px",
            marginTop: "1rem",
            marginLeft: "1rem",
          }}
          onClick={() => {
            savingOtherChargesDataFn(tempOtherChargesData);
            setOtherChargesData(tempOtherChargesData);
            setOtherCharges(false);
          }}
        >
          Confirm
        </Button>
      </div>
    </Drawer>
  );
};

export default OtherChargesDrawer;
